import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconRadiusBottomLeft24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconRadiusBottomLeft24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 6.947v3.303a9.25 9.25 0 0 0 9.25 9.25h3.505a.75.75 0 1 1 0 1.5h-3.506C7.812 21 3 16.187 3 10.25V6.947a.75.75 0 1 1 1.5 0m7.505-3.75a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3.373-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m7.373 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconRadiusBottomLeft24);
